import styled from "styled-components"

export default styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 5px 5px 0 0;
  
  background: radial-gradient(circle at top right, rgba(0,0,0,0.28) 0%,rgba(0,0,0,0) 38%);
`
